class MappingService {
    static metricTableName = "Metrics";
    static metricTableId = -1;

    private static _mappings: Array<Mapping> = null;
    static get mappings() {
        if (MappingService._mappings == null) {
            //MappingService._mappings = []; Avaliar concorrencia
            MappingService.loadMappings();
        }
        return MappingService._mappings;
    }

    static getCurrentMapping() {
        return MappingService.getMapping(workbook.workbookConfig.mappingId);
    }

    static getMetricFieldModel = function (metricId) {
        if (!metricId)
            return null;
        var metric = MappingService.getCurrentMapping().metrics.find(m => m.metricId === metricId);
        return metric;
    }

    static getMetric = function (metricId) {
        return MappingService.getCurrentMapping().getMetric(metricId);
    }

    static getMetricName = function (metricId) {
        var metric = MappingService.getCurrentMapping().getMetricFieldModel(metricId);
        return metric ? metric.nodeName : "";
    }

    static getField(fieldId) {
        if (!fieldId)
            return null;
        let table = MappingService.getCurrentMapping().tables.find(t => t.fields.find(f => f.fieldId === fieldId));
        var field = table ? table.fields.find(f => f.fieldId === fieldId) : null;
        return field;
    }

    static getFieldName(fieldId) {
        var field = MappingService.getCurrentMapping().getField(fieldId);
        return field ? field.nodeName : "";
    }

    static getFilter(filterId) {
        if (!filterId)
            return null;
        var filter = MappingService.getCurrentMapping().filters.find(f => f.id === filterId);
        return filter;
    }

    static getFilterName(filterId) {
        var filter = MappingService.getCurrentMapping().getFilter(filterId);
        return filter ? filter.name : "";
    }

    static getMapping(id) {
        if (!id)
            return null;
        var mapping = MappingService.mappings.find(f => f.id === id);
        return mapping;
    }

    static getMappingName(id) {
        var mapping = MappingService.getMapping(id);
        return mapping ? mapping.name : "";
    }

    static loadMappings() {
        let o = {
            url: urlConfigs.designer + "GetDataSourceMappings",
            data: { },
            dataType: "json",
            async: false,
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            MappingService._mappings = createInstances(Mapping, data.mappings);
        }.bind(this);
        o.failureFunction = function (textStatus, failureText, errorItem: IError) {
            errorItem.userMessage = `Failed to get the mappings`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, failureText);
        };

        irGlobal.requestServer(o);
    }

    private static popoverComponent: Ir.Components.Mapping.MappingTreePopover.IMappingPopover = null;
    static show(options: Ir.Components.Mapping.MappingTreePopover.IMappingPopoverOptions, config: Ir.Components.Mapping.MappingTreePopover.IMappingOptions = null) {
        if (MappingService.popoverComponent == null) {
            let $popover = $(`<mapping-tree-popover params="callback: getComponent, config: config"></mapping-tree-popover>`);
            $popover.appendTo('body');
            ko.applyBindings({
                getComponent(component) {
                    MappingService.popoverComponent = component;
                    MappingService.popoverComponent.show(options);
                },
                config: config
            }, $popover[0]);
        }
        else {
            MappingService.popoverComponent.show(options);
        }
    }
    static hide() {
        MappingService.popoverComponent?.hide();
    }

    static sortFields(a, b) {
        //Move metrics to the top
        if (a.id === MappingService.metricTableId && b.id !== MappingService.metricTableId) return -1;
        if (a.id !== MappingService.metricTableId && b.id === MappingService.metricTableId) return 1;

        if (!loggedUser.alphabeticalOrder) {
            if (a.order !== undefined && b.order !== undefined) {
                return a.order - b.order;
            }
        }

        const textA = a.internalDisplayName || a.name || "";
        const textB = b.internalDisplayName || b.name || "";
        return textA.localeCompare(textB);
    }
}

enum MappingPopoverTypeEnum {
    Metrics,
    NonMetrics,
    Date,
    DateNonDerivedDates,
    NonMetricsNonDerivedDates,
    NonMetricsNonDates,
    Filters,
    All,
    AllNonDerivedDates,
    /** Show all metrics with the Metrics node, this allows you to add all metrics quickly */
    MetricsNode
}